import React, { useRef, useState } from 'react';
import { Button } from "../button/index.js";
import { PopConfirm } from "./PopConfirm.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const PopConfirmButton = ({
  title,
  content,
  type,
  onConfirm,
  onCancel,
  buttonProps
}) => {
  const [open, setOpen] = useState(true);
  const ref = useRef(null);
  return /*#__PURE__*/_jsx(PopConfirm, {
    title: title,
    content: content,
    type: type,
    iconRef: ref,
    open: open,
    onConfirm: () => {
      onConfirm();
      setOpen(false);
    },
    onCancel: () => {
      setOpen(false);
      onCancel();
    },
    children: /*#__PURE__*/_jsx(Button, {
      ref: ref,
      ...buttonProps,
      onClick: e => {
        setOpen(true);
        buttonProps.onClick?.(e);
      }
    })
  });
};